import BaseService from "./BaseService";
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";

class ApiService {
  static fetchData<Response = unknown, Request = any>(
    config: AxiosRequestConfig<Request>,
    includeToken: boolean = true
  ): Promise<AxiosResponse<Response>> {
    if (includeToken) {
      const token = localStorage.getItem("access_token");
      if (token) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        };
      }
    }

    return new Promise<AxiosResponse<Response>>((resolve, reject) => {
      BaseService(config)
        .then((response: AxiosResponse<Response>) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  }
}

export default ApiService;
